<script>
const statusMapping = {
  1: 'check-circle',
  2: 'exclamation-circle',
  3: 'close-circle'
}
export default {
  functional: true,
  render(h, context) {
    const { status } = context.props
    const _type = statusMapping[status]
    return _type && <a-icon type={_type} theme="filled" class={'check-status status' + status} />
  }
}
</script>

<style lang="less">
.check-status {
  &.status1 {
    color: #52c41a;
  }
  &.status2 {
    color: #faad14;
  }
  &.status3 {
    color: #f5222d;
  }
}
</style>
